import React from 'react'
import styled from 'styled-components'

interface InfoPillProps {
  color: string
  info: string
}



const InfoPill: React.FC<InfoPillProps> = ({ color, info }) => {
  return <Pill color={color}>{info}</Pill>
}


const Pill = styled.span<{ color: string }>`
  	background: ${({color}) => color};
    color: var(--gray-0);
  	font-family: SourceSansPro-Regular;
    padding: 2px 8px !important;   
    font-size: 16px;
    font-weight: 600;
    line-height: 120% !important;
    border: none;
    border-radius: 3px;
    padding: 0 14px;
`

export default InfoPill
